import RaceForward from "./racePath/RaceForward.jsx";
import SurfaceButtonStart from "../surfacebuttons/SurfaceButtonStart.jsx";
import RaceTurn from "./racePath/RaceTurn.jsx";
import { useGame } from "../../stores/useGame.js";
import RaceStart from "./racePath/RaceStart.jsx";
import RaceFinish from "./racePath/RaceFinish.jsx";

const BLOCK_SIZE = 6;

const Race = ({ position }) => {
  const preparerace = useGame((state) => state.preparerace);
  return (
    <group position={position}>
      <SurfaceButtonStart
        position={[0, 0.04, BLOCK_SIZE + 1]}
        isActive={preparerace}
      />
      <RaceStart position={[0, 0, 0]} />
      <RaceTurn position={[0, 0, -BLOCK_SIZE]} />
      <RaceForward
        position={[-BLOCK_SIZE, 0, -BLOCK_SIZE]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 2, 0, -BLOCK_SIZE]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 3, 0, -BLOCK_SIZE]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 4, 0, -BLOCK_SIZE]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 5, 0, -BLOCK_SIZE]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 5, 0, 0]}
        rotation={[0, -Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 6, 0, 0]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 6, 0, BLOCK_SIZE]}
        rotation={[0, 0, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 6, 0, BLOCK_SIZE * 2]}
        rotation={[0, 0, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 6, 0, BLOCK_SIZE * 3]}
        rotation={[0, 0, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 6, 0, BLOCK_SIZE * 4]}
        rotation={[0, 0, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 6, 0, BLOCK_SIZE * 5]}
        rotation={[0, Math.PI, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 5, 0, BLOCK_SIZE * 5]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 4, 0, BLOCK_SIZE * 5]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 3, 0, BLOCK_SIZE * 5]}
        rotation={[0, -Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[-BLOCK_SIZE * 3, 0, BLOCK_SIZE * 4]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE * 2, 0, BLOCK_SIZE * 4]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceForward
        position={[-BLOCK_SIZE, 0, BLOCK_SIZE * 4]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <RaceTurn
        position={[0, 0, BLOCK_SIZE * 4]}
        rotation={[0, -Math.PI / 2, 0]}
      />
      <RaceFinish
        position={[0, 0, BLOCK_SIZE * 3]}
        rotation={[0, Math.PI, 0]}
      />
    </group>
  );
};

export default Race;
